import onDemandCallComponent from "./on_demand_call.component";

let onDemandCallModule = angular
  .module("onDemandCall", [])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $urlRouterProvider.otherwise("/onDemandCall");

    $stateProvider.state("onDemandCall", {
      url: "/v2/index.html#/on-demand-service",
      component: "onDemandCall",
      data: {
        requireLogin: true,
        requireACL: "on_demand_call.all",
      },
    });
  })
  .component("onDemandCall", onDemandCallComponent).name;

export default onDemandCallModule;



// WEBPACK FOOTER //
// ./client/app/components/on_demand_call/index.js